import { Star } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const reviews = [
  {
    name: "Marco T.",
    role: "Ha aperto il suo bar a Sesto San Giovanni",
    text: "Corso molto pratico: la parte fiscale mi ha chiarito tutto su Partita IVA e pratiche SUAP. Esame superato al primo colpo.",
  },
  {
    name: "Sara G.",
    role: "Titolare di una tavola calda",
    text: "Docenti preparati e sempre disponibili. La parte HACCP è spiegata con esempi veri di cucina, non solo teoria.",
  },
  {
    name: "Ahmed K.",
    role: "Gestisce un minimarket",
    text: "Da cittadino extra-UE avevo dubbi sui requisiti: mi hanno aiutato con la Dichiarazione di Valore e seguito passo passo.",
  },
  {
    name: "Elena R.",
    role: "Ristorante di famiglia",
    text: "Ho frequentato online restando a gestire il locale. Organizzazione perfetta e attestato arrivato senza problemi.",
  },
];

export default function Testimonianze() {
  return (
    <section id="testimonianze" className="border-t border-line bg-paper py-16 md:py-24" data-testid="testimonianze-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Dicono di noi"
          title="Chi ha già fatto il corso"
          sub="Le esperienze di alcuni corsisti che hanno ottenuto l'abilitazione SAB con ANAS Milano Formazione."
          testid="testimonianze"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.08}>
              <figure
                className="flex h-full flex-col border border-line bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                data-testid={`testimonial-card-${i}`}
              >
                <div className="flex gap-1" aria-label="Valutazione 5 su 5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-brand-amber text-brand-amber" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">
                  "{r.text}"
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy font-heading text-sm font-bold text-white">
                    {r.name.split(" ").map((p) => p[0]).join("")}
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-navy">{r.name}</span>
                    <span className="block text-xs text-slate-500">{r.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
